import { apiClient } from 'pobble-components/dist/api'

const apiApproveComment = id => apiClient.put(`/v3/comments/${id}/approve`)

export { apiApproveComment }
